import matchSwitch, { _ } from 'match-switch';
import { useMemo } from 'react';
import { VscTriangleDown, VscTriangleUp } from 'react-icons/vsc';

interface Props {
  direction: 'asc' | 'desc' | any;
}

export default function TableSortButton({ direction }: Props) {
  const element = useMemo(
    () =>
      matchSwitch(direction, {
        asc: (
          <div className="inline-flex flex-col -space-y-1.5 align-middle">
            <VscTriangleUp className="inline-block text-gray-900" />
            <VscTriangleDown className="inline-block text-gray-300" />
          </div>
        ),
        desc: (
          <div className="inline-flex flex-col -space-y-1.5 align-middle">
            <VscTriangleUp className="inline-block text-gray-300" />
            <VscTriangleDown className="inline-block text-gray-900" />
          </div>
        ),
        [_]: (
          <div className="inline-flex flex-col -space-y-1.5 align-middle">
            <VscTriangleUp className="inline-block text-gray-300" />
            <VscTriangleDown className="inline-block text-gray-300" />
          </div>
        ),
      }),
    [direction]
  );
  return element;
}
